import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "error-msg" }
const _hoisted_3 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_4 = { class: "register-form-row" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_6 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_7 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_8 = { class: "register-form-prices" }
const _hoisted_9 = { class: "register-form-prices-row" }
const _hoisted_10 = { class: "register-form-prices-row-left text" }
const _hoisted_11 = { class: "register-form-prices-row-right text" }
const _hoisted_12 = {
  key: 0,
  class: "register-form-prices-promocode"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "register-form-prices-row" }
const _hoisted_16 = { class: "register-form-prices-row-left text" }
const _hoisted_17 = { class: "register-form-prices-row-right h2" }
const _hoisted_18 = { class: "register-form-foot register-form-foot--alt" }
const _hoisted_19 = { class: "submit-container" }
const _hoisted_20 = {
  key: 1,
  type: "button",
  disabled: "",
  class: "button button--loading"
}
const _hoisted_21 = {
  key: 1,
  class: "error-msg error-msg--alt error-msg--right t-list"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonHover = _resolveComponent("ButtonHover")!
  const _component_ErrorPopin = _resolveComponent("ErrorPopin")!

  return (_openBlock(), _createElementBlock("form", {
    class: "register-form form",
    onSubmit: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
  }, [
    _createElementVNode("h3", {
      class: "register-form-title h4",
      innerHTML: _ctx.title
    }, null, 8, _hoisted_1),
    _createElementVNode("fieldset", null, [
      _createElementVNode("legend", null, _toDisplayString(_ctx.$t('register-form.promo-code')), 1),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.promocode) = $event)),
        onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onPromoBlur && _ctx.onPromoBlur(...args))),
        type: "text",
        name: "promocode",
        maxlength: "64",
        spellcheck: "false",
        autocorrect: "off"
      }, null, 544), [
        [
          _vModelText,
          _ctx.promocode,
          void 0,
          { trim: true }
        ]
      ]),
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.errorPromo), 1)
    ]),
    (_ctx.price > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("fieldset", null, [
            _createElementVNode("legend", null, _toDisplayString(_ctx.$t('register-form.card')), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.number) = $event)),
              onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.v$.number.$touch && _ctx.v$.number.$touch(...args))),
              class: _normalizeClass({ 'error': _ctx.v$.number.$errors.length }),
              type: "text",
              name: "number",
              required: "",
              spellcheck: "false",
              autocorrect: "off"
            }, null, 34), [
              [
                _vModelText,
                _ctx.number,
                void 0,
                { number: true }
              ]
            ]),
            (_ctx.v$.number.$errors.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.v$.number.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("fieldset", null, [
              _createElementVNode("legend", null, _toDisplayString(_ctx.$t('register-form.expiration')), 1),
              _createElementVNode("div", {
                class: _normalizeClass([{ 'error': _ctx.v$.expMonth.$errors.length || _ctx.v$.expYear.$errors.length }, "input-date"])
              }, [
                _withDirectives(_createElementVNode("input", {
                  onKeypress: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onKeyPress && _ctx.onKeyPress(...args))),
                  onKeyup: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onKeyUp && _ctx.onKeyUp(...args))),
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.expMonth) = $event)),
                  onChange: _cache[7] || (_cache[7] = ($event: any) => {if(parseInt(_ctx.expMonth,10)<10)_ctx.expMonth='0'+_ctx.expMonth;}),
                  onBlur: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.v$.expMonth.$touch && _ctx.v$.expMonth.$touch(...args))),
                  type: "number",
                  name: "expMonth",
                  min: "1",
                  max: "12",
                  size: "2",
                  placeholder: "MM",
                  required: "",
                  minlength: "2",
                  maxlength: "2",
                  spellcheck: "false",
                  autocorrect: "off"
                }, null, 544), [
                  [
                    _vModelText,
                    _ctx.expMonth,
                    void 0,
                    { number: true }
                  ]
                ]),
                _hoisted_5,
                _withDirectives(_createElementVNode("input", {
                  onKeypress: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onKeyPress && _ctx.onKeyPress(...args))),
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.expYear) = $event)),
                  onBlur: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.v$.expYear.$touch && _ctx.v$.expYear.$touch(...args))),
                  type: "number",
                  name: "expYear",
                  min: "2022",
                  max: "3000",
                  size: "4",
                  placeholder: "YYYY",
                  required: "",
                  minlength: "4",
                  maxlength: "4",
                  spellcheck: "false",
                  autocorrect: "off"
                }, null, 544), [
                  [
                    _vModelText,
                    _ctx.expYear,
                    void 0,
                    { number: true }
                  ]
                ])
              ], 2),
              (_ctx.v$.expMonth.$errors.length || _ctx.v$.expYear.$errors.length || _ctx.expDateIsInvalid)
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.$t('error.date-invalid')), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("fieldset", null, [
              _createElementVNode("legend", null, _toDisplayString(_ctx.$t('register-form.ccv')), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.cvc) = $event)),
                onBlur: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.v$.cvc.$touch && _ctx.v$.cvc.$touch(...args))),
                class: _normalizeClass({ 'error': _ctx.v$.cvc.$errors.length }),
                name: "card-cvc",
                type: "string",
                min: "0",
                max: "9999",
                maxlength: "4",
                required: "",
                spellcheck: "false",
                autocorrect: "off"
              }, null, 34), [
                [
                  _vModelText,
                  _ctx.cvc,
                  void 0,
                  { trim: true }
                ]
              ]),
              (_ctx.v$.cvc.$errors.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.v$.cvc.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('register-form.promo-code-total')), 1),
        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.formatedPrice(_ctx.discount)), 1)
      ]),
      (_ctx.hasPromoCode || _ctx.hasUnlockProCode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (_ctx.hasPromoCode)
              ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.$t('register-form.promocode-validated')), 1))
              : _createCommentVNode("", true),
            (_ctx.hasUnlockProCode)
              ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.$t('register-form.promocode-unlock-pro')), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("span", _hoisted_16, [
          _createElementVNode("b", null, _toDisplayString(_ctx.$t('register-form.total')), 1)
        ]),
        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.formatedPrice(_ctx.price)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("button", {
        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('prevTab'))),
        type: "button",
        class: "link-secondary text-lg"
      }, _toDisplayString(_ctx.$t('register-form.back')), 1),
      _createElementVNode("div", _hoisted_19, [
        (!_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_ButtonHover, {
              key: 0,
              type: "submit",
              class: "button"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('register-form.submit')), 1)
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock("button", _hoisted_20, _toDisplayString(_ctx.$t('register-form.loading')), 1))
      ])
    ]),
    (_ctx.errors)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_21, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (item, i) => {
            return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(item), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ErrorPopin, { active: _ctx.errorRequest }, null, 8, ["active"])
  ], 32))
}